import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';

export function CustomFieldLoadState({
  pending,
  error,
  retry,
}: {
  pending: boolean;
  error: boolean;
  retry: () => void;
}): JSX.Element | null {
  const { t } = useTranslation();
  if (pending)
    return (
      <div aria-busy="true">
        <Skeleton className="h-24 w-full" />
      </div>
    );
  if (error)
    return (
      <div role="alert" className="flex flex-col items-start gap-2">
        <p className="text-sm text-muted-foreground">{t('customFields.loadError')}</p>
        <Button type="button" variant="outline" size="sm" onClick={retry}>
          {t('common.retry')}
        </Button>
      </div>
    );
  return null;
}
